export enum FormField {
  typography = 'typography',
  string = 'string',
  textarea = 'textarea',
  fio = 'fio',
  nickname = 'nickname',
  number = 'number',
  phone = 'phone',
  email = 'email',
  phoneOrEmail = 'phoneOrEmail',
  password = 'password',
  repeatPassword = 'repeatPassword',
  checkbox = 'checkbox',
  checkboxGroup = 'checkboxGroup',
  radioGroup = 'radioGroup',
  radio = 'radio',
  code = 'code',
  date = 'date',
  time = 'time',
  birthday = 'birthday',
  select = 'select',
  selectTags = 'selectTags',
  autocomplete = 'autocomplete',
  button = 'button',
  address = 'address',
  inputMap = 'inputMap',
  fileUploader = 'fileUploader',
  divider = 'divider',
  colorPicker = 'colorPicker',
  iconPicker = 'iconPicker',
}

export type FormFieldType = keyof typeof FormField
